var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 61 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.19336,
    width: 55.8354,
    height: 50.2527,
    rx: 12,
    fill: "url(#paint0_linear_186_3921)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.339 55.7605L33.7786 55.353L31.7567 35.1082L27.3044 35.3876L29.339 55.7605Z",
    fill: "#985647",
    stroke: "black",
    strokeWidth: 0.13959
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3444 55.945L29.5676 55.7409L27.5409 35.4473L25.3112 35.5866L27.3444 55.945Z",
    fill: "#DDAF9C",
    stroke: "black",
    strokeWidth: 0.13959
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3709 40.4065C38.3754 40.4331 38.3961 40.4292 38.423 40.4266L48.6023 39.416C48.629 39.4134 48.6498 39.4133 48.6488 39.3865C48.6108 38.3828 47.3865 7.25135 41.4577 7.79547C33.062 8.56599 38.2021 39.4071 38.3709 40.4065Z",
    fill: "#51210C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3758 40.4335C38.3758 40.4334 38.3759 40.4334 38.3759 40.4334L48.6424 39.4142C48.6477 39.4137 48.6466 39.4126 48.6517 39.4137C48.8207 39.4497 64.6027 42.819 58.609 43.3691C50.0756 44.1522 38.3773 40.434 38.3759 40.4336C38.3758 40.4336 38.3759 40.4335 38.3758 40.4335Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3758 40.4335C38.3758 40.4334 38.3759 40.4334 38.3759 40.4334L48.6424 39.4142C48.6477 39.4137 48.6466 39.4126 48.6517 39.4137C48.8207 39.4497 64.6027 42.819 58.609 43.3691C50.0756 44.1522 38.3773 40.434 38.3759 40.4336C38.3758 40.4336 38.3759 40.4335 38.3758 40.4335V40.4335Z",
    stroke: "black",
    strokeWidth: 0.161277,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27064 42.2702L17.4122 41.7562L38.3745 40.4363C38.3745 40.4363 32.923 8.58401 41.4572 7.80078L28.4268 8.99665L15.3964 10.1925C8.18425 10.8544 6.63302 15.8599 9.27064 42.2702Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71899 16.5927C7.76424 21.2048 8.03101 29.0243 9.34334 42.1848L17.4065 41.6758L38.2802 40.3614L38.2796 40.3575C38.2695 40.2971 38.2547 40.2075 38.2357 40.0906C38.1978 39.8569 38.1434 39.5141 38.0772 39.0776C37.9447 38.2045 37.765 36.9565 37.576 35.4566C37.1981 32.4568 36.7831 28.4483 36.6349 24.4146C36.4868 20.3822 36.605 16.319 37.2963 13.2124C37.642 11.6594 38.1321 10.3393 38.8084 9.3812C39.2644 8.73509 39.8065 8.25202 40.4462 7.97454L15.4044 10.2728C13.6094 10.4375 12.1795 10.8715 11.0791 11.8308C9.97865 12.7902 9.19681 14.2844 8.71899 16.5927Z",
    stroke: "black",
    strokeWidth: 0.161277
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4469 1.02213C15.0674 1.2828 14.3183 2.72406 14.9319 3.93675C15.506 5.07103 16.9999 5.4475 18.0816 4.73044L20.7647 2.9518C21.0562 2.75855 21.2564 2.47752 21.3451 2.16592L22.4297 2.03595C23.7628 1.87621 24.9786 2.78268 25.1452 4.06061L27.9864 25.8491C28.0419 26.275 28.4472 26.5772 28.8915 26.524C29.3359 26.4707 29.6511 26.0822 29.5956 25.6562L26.7544 3.86779C26.4767 1.73791 24.4504 0.227121 22.2286 0.493356L20.8002 0.664513C20.479 0.437955 20.0644 0.338537 19.6474 0.417335L16.4469 1.02213Z",
    fill: "#985647"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.062,
    cy: 25.5074,
    rx: 3.32262,
    ry: 3.18511,
    fill: "#985647"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8098 25.4727C34.8098 28.4907 32.2526 30.9661 29.0619 30.9661C25.8712 30.9661 23.314 28.4907 23.314 25.4727C23.314 22.4547 25.8712 19.9794 29.0619 19.9794C32.2526 19.9794 34.8098 22.4547 34.8098 25.4727Z",
    stroke: "#985647",
    strokeWidth: 0.806386
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_3921",
    x1: 11.1671,
    y1: 1.62296,
    x2: 38.3566,
    y2: 82.3121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0342874,
    stopColor: "#F8DDCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFAF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/email-success.d1ae8693a3c4ab9b5abfa13f26de9985.svg";
export { ForwardRef as ReactComponent };